const l = {
  name: "Poland",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3.8,0H0v6c0,3,2.3,5.6,5.2,5.9l2.1,8.4C7.8,22.5,9.8,24,12,24c2.2,0,4.2-1.5,4.7-3.7l0,0l2.1-8.4
			C21.7,11.6,24,9,24,6V0h-3.8l-0.8,3.8c-0.1,0.6-0.6,1.1-1.3,1.2c-4-1.3-8.3-1.3-12.3,0C5.2,4.9,4.7,4.5,4.6,3.8L3.8,0z M2,6V2h0.2
			l0.4,2.2C3,5.8,4.4,7,6,7h0.2l0.2-0.1c3.7-1.2,7.7-1.2,11.4,0L17.8,7H18c1.6,0,3-1.2,3.4-2.8L21.8,2H22v4c0,2.2-1.8,4-4,4h-0.8
			l-1.7,6.8c-2.2,1.3-4.9,1.3-7,0L6.8,10H6C3.8,10,2,8.2,2,6z M9.1,19.3c1.9,0.6,3.9,0.6,5.8,0l-0.1,0.6l0,0
			C14.4,21.1,13.3,22,12,22c-1.3,0-2.4-0.9-2.8-2.2l0,0L9.1,19.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Poland
};
